import { useState } from 'react'

import { CompetenciesCompetenciesListDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { useCompetenciesFeatures } from 'modules/competencies/hooks/useCompetenciesFeatures'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { CompetenciesDataCollection } from './CompetenciesDataCollection/index'
import { NewCompetencyWizard } from './NewCompetencyWizard'

const CompetenciesList = () => {
  const [showNewCompetencyWizard, setShowNewCompetencyWizard] = useState(false)

  const { data, loading, error } = useQuery(CompetenciesCompetenciesListDocument)

  const { isJobCatalogTreeEnabled } = useCompetenciesFeatures()

  const canManageCompetencies = data?.competencies?._policies?.competenciesManage?.can ?? false
  const canImportResources = data?.universalImporter._policies.importResources.can ?? false

  const canManageJobCatalogTree = data?.jobCatalog._policies.jobCatalogTreeManage.can ?? false
  const canSeeJobCatalogTree = data?.jobCatalog._policies.jobCatalogTreeSee.can ?? false

  const canImportCompetencies =
    isJobCatalogTreeEnabled && canManageCompetencies && canImportResources

  const canBulkAssignCompetencies =
    isJobCatalogTreeEnabled && canManageJobCatalogTree && canImportResources

  const competencyGroups = data?.competencies.competencyGroups ?? []
  const jobCatalogRoles = data?.jobCatalog.roles ?? []

  return (
    <ResponsivePage.Body loading={loading} error={error}>
      <CompetenciesDataCollection
        competencyGroups={competencyGroups}
        jobCatalogRoles={jobCatalogRoles}
        canManageCompetencies={canManageCompetencies}
        canImportCompetencies={canImportCompetencies}
        canBulkAssignCompetencies={canBulkAssignCompetencies}
        canSeeJobCatalogTree={canSeeJobCatalogTree}
        onNewCompetency={() => setShowNewCompetencyWizard(true)}
      />

      {showNewCompetencyWizard && (
        <NewCompetencyWizard
          canManageJobCatalogTree={canManageJobCatalogTree}
          onClose={() => setShowNewCompetencyWizard(false)}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default CompetenciesList
